import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api';
import { queryKeys } from '../queryKeys';
import type { ReviewRecord } from '../types';

import { useCurrentUser } from './useAuth';

export function useFeedbackResults() {
  const { data: currentUser } = useCurrentUser();
  return useQuery({
    queryKey: queryKeys.feedbackResults(currentUser?.user_id ?? ''),
    enabled: !!currentUser,
    queryFn: () =>
      apiRequest<{ tse: string; reviews: ReviewRecord[] }>('/api/feedback/results', {
        method: 'POST',
        body: { action: 'results' },
      }),
  });
}
